<div class="cus-snackbar">
    <div class="left-sec">
        <mat-icon *ngIf="data.type === 'SUCCESS'">done</mat-icon>
        <mat-icon *ngIf="data.type === 'ERROR'">report_proble</mat-icon>
        <span>{{ data.message }}</span>
    </div>
    <button mat-button (click)="data.snackbar.dismiss()" class="button">{{ data.buttonText }}</button>
</div>